import { sharedPage } from '../../assets/shared.styles';

export const styles = {
  container: { ...sharedPage.container, flexDirection: 'column', alignItems: 'center' },

  stepperBox: { width: '100%', mb: '2rem' },
  step: {},
  label: {},
};
